var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCamera(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_41298",
    "data-name": "Group 41298",
    transform: "translate(14856 5910)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_15668",
    "data-name": "Rectangle 15668",
    width: 40,
    height: 40,
    transform: "translate(-14856 -5910)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "photo-camera",
    transform: "translate(-14853.5 -5904)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_41295",
    "data-name": "Group 41295",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_41294",
    "data-name": "Group 41294"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_37058",
    "data-name": "Path 37058",
    d: "M30.815,51.974H27.163L25.147,48.93A4.19,4.19,0,0,0,21.685,47.1h-8.37A4.19,4.19,0,0,0,9.853,48.93L7.837,51.974H4.185A4.173,4.173,0,0,0,0,56.158V70.919A4.173,4.173,0,0,0,4.185,75.1h26.63A4.173,4.173,0,0,0,35,70.919V56.158A4.173,4.173,0,0,0,30.815,51.974ZM17.5,71.68a9.416,9.416,0,1,1,9.435-9.4A9.433,9.433,0,0,1,17.5,71.68ZM30.283,57.87H28.609a1.238,1.238,0,0,1,0-2.473H30.13a1.235,1.235,0,0,1,1.293,1.179A1.2,1.2,0,0,1,30.283,57.87Z",
    transform: "translate(0 -47.104)",
    fill: "currentColor"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_41297",
    "data-name": "Group 41297",
    transform: "translate(12.25 9.929)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_41296",
    "data-name": "Group 41296",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_37059",
    "data-name": "Path 37059",
    d: "M170.114,180.736a5.231,5.231,0,1,0,5.25,5.212A5.261,5.261,0,0,0,170.114,180.736Z",
    transform: "translate(-164.864 -180.736)",
    fill: "currentColor"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/camera.2ee1037e2751c659e35e506c8e795c06.svg";
export { ForwardRef as ReactComponent };